import apiService from '../api';

const surveyApiInstructorMixin = {
  async createSurvey(surveyData) {
    return apiService.request('/surveys', {
      method: 'POST',
      body: JSON.stringify(surveyData)
    });
  },

  async getInstructorSurveys() {
    return apiService.request('/surveys');
  },

  async getSurvey(surveyId) {
    return apiService.request(`/surveys/${surveyId}`);
  },

  async updateSurvey(surveyId, surveyData) {
    return apiService.request(`/surveys/${surveyId}`, {
      method: 'PUT',
      body: JSON.stringify(surveyData)
    });
  },

  async deleteSurvey(surveyId) {
    return apiService.request(`/surveys/${surveyId}`, {
      method: 'DELETE'
    });
  },

  async getSurveyResults(surveyId) {
    return apiService.request(`/surveys/${surveyId}/results`);
  },

  async assignSurveyToCourse(surveyId, courseId) {
    return apiService.request(`/surveys/${surveyId}/assign-course`, {
      method: 'POST',
      body: JSON.stringify({ course_id: courseId })
    });
  },

  /**
   * Send a survey to several courses at once (e.g. every course in a
   * program). A student enrolled in more than one of them still only gets
   * one assignment/email — the server de-dupes per student across the list.
   */
  async assignSurveyToCourses(surveyId, courseIds) {
    return apiService.request(`/surveys/${surveyId}/assign-courses`, {
      method: 'POST',
      body: JSON.stringify({ course_ids: courseIds })
    });
  },

  /** Admin-only: send a published survey to every active course at once. */
  async assignSurveyToAllCourses(surveyId) {
    return apiService.request(`/surveys/${surveyId}/assign-all`, {
      method: 'POST'
    });
  },

  async unassignSurveyCourse(surveyId, courseAssignmentId) {
    return apiService.request(`/surveys/${surveyId}/course-assignments/${courseAssignmentId}`, {
      method: 'DELETE'
    });
  },

  /** The class link (shareable in a group chat) plus each student's personal link. */
  async getCourseAssignmentLinks(surveyId, courseAssignmentId) {
    return apiService.request(`/surveys/${surveyId}/course-assignments/${courseAssignmentId}/links`);
  },

  async getCourses() {
    return apiService.request('/courses');
  },

  /** Admin-only: instructors explicitly granted management access to this survey. */
  async getSurveyAccess(surveyId) {
    return apiService.request(`/surveys/${surveyId}/access`);
  },

  /** Admin-only: grant one instructor full management access to a survey. */
  async grantSurveyAccess(surveyId, instructorId, expiresAt) {
    return apiService.request(`/surveys/${surveyId}/access`, {
      method: 'POST',
      body: JSON.stringify({ instructorId, expiresAt: expiresAt || undefined })
    });
  },

  /** Admin-only: revoke a previously granted survey access. */
  async revokeSurveyAccess(surveyId, grantId) {
    return apiService.request(`/surveys/${surveyId}/access/${grantId}/revoke`, {
      method: 'POST'
    });
  },
};

export default surveyApiInstructorMixin;
